/*
Copyright 2023 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
export default {
  PAUSE: "media.pauseStart",
  PLAY: "media.play",
  BUFFER_START: "media.bufferStart",
  AD_START: "media.adStart",
  Ad_BREAK_START: "media.adBreakStart",
  SESSION_END: "media.sessionEnd",
  SESSION_START: "media.sessionStart",
  SESSION_COMPLETE: "media.sessionComplete",
  PING: "media.ping",
  AD_BREAK_COMPLETE: "media.adBreakComplete",
  AD_COMPLETE: "media.adComplete",
  AD_SKIP: "media.adSkip",
  BITRATE_CHANGE: "media.bitrateChange",
  CHAPTER_COMPLETE: "media.chapterComplete",
  CHAPTER_SKIP: "media.chapterSkip",
  CHAPTER_START: "media.chapterStart",
  ERROR: "media.error",
  STATES_UPDATE: "media.statesUpdate"
};